import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const CustomerIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M10.333 13.75a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0M14.5 14.583a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.054 4.804C7.401 3.58 9.345 3 11.917 3c2.383 0 4.305.59 5.708 1.787 1.268 1.084 2.026 2.591 2.359 4.383C21.21 9.588 22 10.858 22 12.167c0 1.467-.973 2.846-2.377 3.095-1.202 3.466-4.09 6.071-7.623 6.071-3.532 0-6.421-2.605-7.623-6.071C2.973 15.012 2 13.634 2 12.167c0-1.3.776-2.56 1.988-2.987.241-1.759.856-3.276 2.066-4.376M4.708 10.71c-.528.1-1.041.662-1.041 1.457 0 .917.644 1.468 1.166 1.468h.795l.173.604c.928 3.24 3.42 5.428 6.199 5.428s5.271-2.188 6.199-5.428l.173-.604h.794c.522 0 1.167-.55 1.167-1.468 0-.767-.478-1.317-.985-1.445-2.97 1.147-5.281 1.126-6.992.522-1.047-.37-1.842-.948-2.402-1.568-.598.62-1.404.946-2.169 1.096-1.106.217-2.276.11-3.077-.062m13.608-1.383c-.291-1.435-.89-2.518-1.774-3.273-1.014-.866-2.509-1.387-4.625-1.387-2.345 0-3.818.53-4.742 1.37-.786.715-1.277 1.745-1.502 3.143.555.065 1.201.073 1.792-.043.869-.171 1.445-.561 1.653-1.257a.833.833 0 0 1 1.565-.088c.242.566.932 1.423 2.228 1.88 1.184.418 2.942.523 5.405-.345"
      clipRule="evenodd"
    />
  </BaseIcon>
)
